import { FleLayout } from "components/views/fle/FleLayout"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { IlloFinancial } from "components/views/atoms/Illustrations"
import { LeftArrowAndSpace, SpacerSwitcher, SwitchH1ToH2 } from "components/views/fle/Molecules"
import { Body } from "components/views/atoms/Bodies"
import { FleLinkWrapper } from "components/views/atoms/Links"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import React from "react"

export const FinancialSupport = ({
  companyName,
  coverageAmount,
  coveragePercent,
  currencySymbol,
  onBack,
  onComplete
}) => (
  <FleLayout>
    <LeftArrowAndSpace onBack={onBack} />
    <div className="no-pointer-events">
      <FlexRowCenter>
        <IlloFinancial />
      </FlexRowCenter>
    </div>
    <SpacerSwitcher />
    <SwitchH1ToH2>Get financial support for your journey.</SwitchH1ToH2>
    <Spacer height={0.5} />
    <Body color="black-80">
      Thanks to {companyName}, your benefit covers {coveragePercent}% for the cost of eligible care, up to{" "}
      {currencySymbol}
      {coverageAmount.toLocaleString()}.
    </Body>
    <Spacer height={0.5} />
    <Body color="black-80">
      You can use your benefit toward family-forming expenses from eligible Carrot providers.
    </Body>
    <FleLinkWrapper spacerHeight={1.5}>
      <ArrowLink onClick={onComplete}>Continue</ArrowLink>
    </FleLinkWrapper>
  </FleLayout>
)
